import type { BlogPost } from "@decocms/apps-blog/types";

export const BLOG_PATH = "/blog";

export const postUrl = (slug: string) => `${BLOG_PATH}/${slug}`;
export const categoryUrl = (slug: string) => `${BLOG_PATH}/category/${slug}`;

const DECOIMS_ASSET = "https://decoims.com/danielatombini/";

/**
 * Imagem do blog no tamanho em que é exibida: arquivo no decoims passa pelo
 * otimizador dele (como o resto do site); qualquer outra URL fica como está.
 */
export function blogImage(src: string, width: number, height?: number): string {
  if (!src.startsWith(DECOIMS_ASSET)) return src;
  const params = new URLSearchParams({
    src: src.slice("https://decoims.com/".length),
    width: String(width),
  });
  if (height) params.set("height", String(height));
  params.set("fit", "cover");
  return `https://decoims.com/image?${params}`;
}

/** "2026-10-16" → "16 de outubro de 2026" (sem fuso: a data já é só o dia). */
export function formatPostDate(date?: string): string {
  if (!date || !/^\d{4}-\d{2}-\d{2}/.test(date)) return "";
  const [year, month, day] = date.slice(0, 10).split("-").map(Number);
  return new Date(Date.UTC(year, month - 1, day)).toLocaleDateString("pt-BR", {
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** O excerpt migrado do WordPress às vezes é o texto inteiro do post. */
export function shortExcerpt(text?: string, max = 160): string {
  const clean = (text ?? "").replace(/\s*\[(?:…|\.\.\.)\]\s*$/, "").trim();
  if (clean.length <= max) return clean;
  return `${clean.slice(0, clean.lastIndexOf(" ", max)).replace(/[,.;:]$/, "")}…`;
}

/** Só o que um card precisa — o `content` (HTML do post inteiro) não viaja
 *  pro payload de hidratação das listagens. */
export type PostSummary = Pick<BlogPost, "title" | "slug" | "date" | "image" | "alt"> & {
  excerpt: string;
  category?: { name: string; slug: string };
};

export function toPostSummary(post: BlogPost): PostSummary {
  return {
    title: post.title,
    slug: post.slug,
    date: post.date,
    image: post.image,
    alt: post.alt,
    excerpt: shortExcerpt(post.excerpt),
    category: post.categories?.[0]
      ? { name: post.categories[0].name, slug: post.categories[0].slug }
      : undefined,
  };
}
